import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconInfoCircle = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#02263c"} className={`info-circle ${props.className}`} viewBox="0 0 72 72">
        <path d="M337.17,377.93a36.22,36.22,0,0,1,0,36.14,35.78,35.78,0,0,1-13.1,13.1,36.22,36.22,0,0,1-36.14,0,35.78,35.78,0,0,1-13.1-13.1,36.22,36.22,0,0,1,0-36.14,35.78,35.78,0,0,1,13.1-13.1,36.22,36.22,0,0,1,36.14,0A35.78,35.78,0,0,1,337.17,377.93ZM318,418.5V411a1.44,1.44,0,0,0-1.5-1.5H312v-24a1.44,1.44,0,0,0-1.5-1.5h-15a1.44,1.44,0,0,0-1.5,1.5V393a1.44,1.44,0,0,0,1.5,1.5H300v15h-4.5A1.44,1.44,0,0,0,294,411v7.5a1.44,1.44,0,0,0,1.5,1.5h21a1.44,1.44,0,0,0,1.5-1.5Zm-6-42V369a1.44,1.44,0,0,0-1.5-1.5h-9A1.44,1.44,0,0,0,300,369v7.5a1.44,1.44,0,0,0,1.5,1.5h9a1.44,1.44,0,0,0,1.5-1.5Z" transform="translate(-270 -360)"/>
    </IconWrapper>
);

export default memo(IconInfoCircle);
